function findHashFromEntry(): string | undefined {
  try {
    const entry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
    if (!entry) return

    const index = entry.name.indexOf('#')
    if (index < 0) return

    const hash = entry.name.substring(index)
    if (hash.includes('tgWebApp')) return hash
  } catch (e) {
    console.error(e)
  }
}

export function getLocationHash(): string {
  const telegram = 'TelegramWebviewProxy' in window
  if (telegram) {
    const entry = findHashFromEntry()
    if (entry) return entry
  }
  return window.location.href
}
